import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '..';

export const selectUserRequestState = (state: RootState) => state.userRequest;

export const userRequestStateSelector = createSelector(selectUserRequestState, (state) => state);